module.exports = __webpack_public_path__ + "img/nono_awaken.ce286b5b.png";